export function groupSplits(list) {
    const rows = [];
    const byGroup = new Map();
    for (const r of list) {
        if (!r.splitGroupId) {
            rows.push({ primary: r, parts: [r] });
            continue;
        }
        const hit = byGroup.get(r.splitGroupId);
        if (hit) {
            hit.parts.push(r);
            hit.parts.sort((a, b) => (a.splitPart || 0) - (b.splitPart || 0));
            hit.primary = hit.parts[0];
        }
        else {
            const row = { primary: r, parts: [r] };
            byGroup.set(r.splitGroupId, row);
            rows.push(row);
        }
    }
    return rows;
}
